import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts'
import './styles/tokens.css'
import './styles/touch.css'
import './i18n'
import App from './App.tsx'
import { CoreProvider } from './core'
import { installErrorCapture } from './error_capture'
import { RootErrorBoundary } from './RootErrorBoundary'
import { installBreadcrumbs } from './observability/breadcrumbs'
import { setupStatusBar } from './native/status_bar'
import { disableNativeAccessoryBar } from './native/keyboard'

// PR-22: install global error capture before first render so
// bundle-eval errors and first-paint exceptions get reported.
installErrorCapture()

// PR-31: install click breadcrumb listener. Fetch crumbs are recorded
// inside `apiFetch`, so no separate hook is needed for them.
installBreadcrumbs()

// PR-29: configure native status bar (no-op on web build).
setupStatusBar()

// PR-38: hide iOS WKWebView's keyboard accessory toolbar (Capacitor only;
// no-op in regular browsers, where iOS Safari shows its own bar that web
// has no API to hide).
disableNativeAccessoryBar()

// PR-30: register the PWA service worker after first paint. Skip when
// running inside Capacitor (the native shell handles caching) and skip
// in dev (Vite ships fresh modules; an SW only causes confusion).
if (
  'serviceWorker' in navigator &&
  !window.location.protocol.startsWith('capacitor') &&
  import.meta.env.PROD
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.warn('SW register failed:', err)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary>
      <CoreProvider>
        <App />
      </CoreProvider>
    </RootErrorBoundary>
  </StrictMode>,
)
